import { styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const confirmationDialogPaperPropsStyle = {
  padding: '1rem',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  maxWidth: '21.8rem',
  width: '100%',
  position: 'relative',

  [theme.breakpoints.up('sm')]: {
    maxWidth: '30rem',
    padding: '1.5rem',
  },

  [theme.breakpoints.up('md')]: {
    maxWidth: '40.625rem',
    padding: '2rem',
  },
};

export const StyledIconButton = styled('button')(({ theme }) => ({
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  color: theme.palette.common.white,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
}));

export const StyledDialogContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
  textAlign: 'center',
  padding: '1rem',
  width: '100%',
  maxHeight: '40rem',
}));
